/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "a52bd75850a04849a07d4500b4d0fba8",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "a52bd75850a04849a07d4500b4d0fba8",
            "region": "us-east-1"
        }
    },
    "aws_appsync_graphqlEndpoint": "https://bg7oak56vvgd3nvp3e7hrxrfme.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-gbh3x4yz7nb57l244f5w3de5iy",
    "aws_cognito_identity_pool_id": "us-east-1:87523d2e-57fd-4597-abbe-b0cea15303cb",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_OSKDlI6JB",
    "aws_user_pools_web_client_id": "1ba8vcrrfr9f5p650bf6fdglas",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "puppymarketplaces155206-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
